import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  Typography,
  Divider,
  Grid,
  useTheme,
  Button,
  TextField,
  MenuItem,
  Autocomplete,
  Checkbox,
  Paper,
  TableBody,
  Table,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  IconButton,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import { GET, POST, PUT } from "../Generic/CrudRequest";
import Icons from "../../Utils/Icons";
import { LocationEdit, LocationAdd, ubicacionContactos } from "./LocationAddOrEdit";
import { UnfoldMore } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export default function AddOrEditLocations({ config }) {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [title, setTitle] = useState("");
  const [locationData, setLocationData] = useState(new LocationAdd());
  const [errors, setErrors] = useState({});
  const [tiposUbicacion, setTiposUbicacion] = useState([]);
  const [tipoUbicacion, setTipoUbicacion] = useState(0);
  const [countrys, setCountrys] = useState([]);
  const [country, setCountry] = useState(0);
  const [ubicacionContactosData, setUbicacionContactosData] = useState(new ubicacionContactos());
  const [draggedRow, setDraggedRow] = useState(null);
  const language = localStorage.getItem("language");

  const [rowsubicacionContactos, setRowsUbicacionContactos] =
    useState([]);
  //contactos
  const [contact, setContacts] = useState([]);
  const [selectedOptionContacts, setSelectedOptionContacts] =
    useState(null); // Estado para el valor seleccionado
  //checked
  const [selectedOptionCheck, setSelectedOptionCheck] = useState(false); // Estado para el valor seleccionado

  useEffect( () => {
    const fetchData = async () => {
    if (location.pathname.includes("/Ubicaciones/Editar")) {
      setTitle(t("locations.addOrEdit.edit"));
      const locationId = getLocationIdFromPath(location.pathname);
      await getLocationById(locationId);

    } else {
      setTitle(t("locations.addOrEdit.add"));
    }
    setSelectedOptionContacts(null);
    await fetchLocationsType();
    await fetchCountrys();
    await fetchContacts();
    }
    fetchData();
  }, [location.pathname, t]);




  const getLocationIdFromPath = (pathname) => {
    const parts = pathname.split("/");
    return parts[parts.length - 1];
  };

  const getLocationById = async (locationId) => {
    const dataLocation = await GET(`${config.url}/api/Location/${locationId}`);
    const updateDataLocation = new LocationEdit(dataLocation);

    setTipoUbicacion(updateDataLocation.idUbicacionTipo);
    setCountry(updateDataLocation.idPais);
    await setSelectedOptionContacts(updateDataLocation.ubicacionContactos);

    //si no tiene orden se les agrega por default
    updateDataLocation.ubicacionContactos.forEach((row, idx) => {
      if (row.orden == null) {
        row.orden = idx + 1;
      }
    });

    await setRowsUbicacionContactos(
      updateDataLocation.ubicacionContactos
    );

    setLocationData(updateDataLocation);
  };

  const fetchLocationsType = async () => {
    const tiposUbicacionData = await GET(`${config.url}/api/LocationType`);
    setTiposUbicacion(tiposUbicacionData);
  };

  const fetchCountrys = async () => {
    const contrysData = await GET(`${config.url}/api/Pais`);
    setCountrys(contrysData);
  };


  const addLocation = async () => {
    const requiredFields = [
      "idUbicacionTipo",
      "nombre",
      "codigo",
      "ciudad",
      "estado",
      "idPais",
    ];
    const newErrors = {};

    if (locationData.email !== "" && !validateEmail(locationData.email)) {
      newErrors.email = t("validation.emailFormat");
    }

    requiredFields.forEach((field) => {
      const fieldValue = getFieldByPath(locationData, field);
      if (!fieldValue || fieldValue === "") {
        newErrors[field] = t("validation.requiredField");
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    locationData.ubicacionContactos = null;
    locationData.ubicacionContactos = rowsubicacionContactos;
    await POST(`${config.url}/api/Location`, locationData);
    navigate("/Ubicaciones");
  };

  const editLocation = async () => {
    const requiredFields = [
      "idUbicacionTipo",
      "nombre",
      "codigo",
      "ciudad",
      "estado",
      "idPais",
    ];
    const newErrors = {};

    if (locationData.email !== "" && !validateEmail(locationData.email)) {
      newErrors.email = t("validation.emailFormat");
    }

    requiredFields.forEach((field) => {
      const fieldValue = getFieldByPath(locationData, field);
      if (!fieldValue || fieldValue === "") {
        newErrors[field] = t("validation.requiredField");
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    
    locationData.ubicacionContactos = null;
    locationData.ubicacionContactos = rowsubicacionContactos;
    await PUT(`${config.url}/api/Location`, locationData);
    navigate("/Ubicaciones");
  };

  const getFieldByPath = (object, path) => {
    const pathArray = path.split(".");
    let value = object;
    for (const prop of pathArray) {
      value = value[prop];
      if (value === undefined) break;
    }
    return value;
  };

  const handleSubmit = async () => {
    if (title === t("locations.addOrEdit.add")) {
      await addLocation();
    } else if (title === t("locations.addOrEdit.edit")) {
      await editLocation();
    }
  };

  const handleChangeLocationsType = (event) => {
    setTipoUbicacion(event.target.value);
    setLocationData({
      ...locationData,
      idUbicacionTipo: event.target.value,
    });
  };

  const handleChangeCountrys = (event) => {
    setCountry(event.target.value);
    setLocationData({
      ...locationData,
      idPais: event.target.value,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLocationData({
      ...locationData,
      [name]: value,
    });

    if (name === "email" && value.trim() !== "") {
      if (!validateEmail(value)) {
        setErrors({
          ...errors,
          [name]: t("validation.emailFormat"),
        });
      } else {
        setErrors({
          ...errors,
          [name]: "",
        });
      }
    }
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleNumberInput = (e) => {
    const key = e.key;

    if (
      !/^[0-9]$/.test(key) &&
      !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(key)
    ) {
      e.preventDefault();
    }
  };
  //#region Checkbox
  const handleCheckboxChange = (event, checked) => {
    setUbicacionContactosData((prevState) => ({
      ...prevState,
      envioCorreo: checked,
    }));
    setSelectedOptionCheck(checked);
  };

  //#endregion

  //#region Agregar
  const handleChangeAgregar = (event, value) => {
    const requiredFields = ["idContacto"];
    const newErrors = {};

    requiredFields.forEach((field) => {
      const fieldValue = getFieldByPath(ubicacionContactosData, field);
      if (!fieldValue || fieldValue === "") {
        newErrors[field] = t("validation.requiredField");
      }
    });


    if (ubicacionContactosData.idContacto !== null) {
      const elementoEncontrado = buscarElementoPorId(
        ubicacionContactosData.idContacto
      );
      if (elementoEncontrado) {
        newErrors["idContacto"] =
          t("validation.contactAlreadyExists");
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    if (ubicacionContactosData.idContacto !== null) {
      //obtenemos el index mas alto
      const highestIndex = rowsubicacionContactos.reduce(
        (maxIndex, currentItem) => {
          return currentItem.orden > maxIndex ? currentItem.orden : maxIndex;
        },
        0
      );

      //agreamos el index uno mas
      ubicacionContactosData.orden = highestIndex + 1;
      //se agrega a la tabla
      setRowsUbicacionContactos([
        ...rowsubicacionContactos,
        ubicacionContactosData,
      ]);
    }

    setUbicacionContactosData(new ubicacionContactos());
    setSelectedOptionContacts(null);
    setSelectedOptionCheck(false);
    setErrors(newErrors);
  };

  //#endregion

  // Función para buscar un elemento por ID
  const buscarElementoPorId = (id) => {
    // Utilizando el método find para encontrar el elemento con el ID proporcionado
    return rowsubicacionContactos.find(
      (item) => item.idContacto === id
    );
  };
  // #region Contacts
  const fetchContacts = async () => {
    const contact = await GET(`${config.url}/api/Contact/`);
    setContacts(contact);
  };

  const isOptionEqualToValueContacts = (option, value) => {
    return option.idContacto === value.idContacto; // Comparar el valor de la opción con el valor seleccionado
  };

  const getOptionLabelContacts = (option) => {
    return option ? option.correo || "" : ""; // Renderizar solo la descripción como etiqueta de opción
  };

  const handleChangeContacts = (
    event,
    selectedOptionContacts
  ) => {
    if (selectedOptionContacts !== null) {
      setUbicacionContactosData((prevState) => ({
        ...prevState,
        idContacto: selectedOptionContacts.idContacto,
        correo: selectedOptionContacts.correo,
      }));
    }
    setSelectedOptionContacts(selectedOptionContacts); // Actualizar el valor seleccionado
  };
  //#endregion


  const handleRemoveUnit = (index) => {
    const updatedRows = [...rowsubicacionContactos];
    updatedRows.splice(index, 1);

    updatedRows.forEach((row, idx) => {
      row.orden = idx + 1;
    });

    setRowsUbicacionContactos(updatedRows);
  };

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("index", index);
    setDraggedRow(index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, targetIndex) => {
    const draggedIndex = e.dataTransfer.getData("index");
    const newData = [...rowsubicacionContactos];
    const movedRow = newData.splice(draggedIndex, 1)[0];
    newData.splice(targetIndex, 0, movedRow);

    newData.forEach((row, idx) => {
      row.orden = idx + 1;
    });
    setRowsUbicacionContactos(newData);
  };

  const handleDragEnd = () => {
    setDraggedRow(null);
  };

  return (
    <Card
      variant="outlined"
      sx={{
        overflow: "hidden",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
        border: "1px solid rgba(0, 0, 0, 0.1)",
        borderRadius: 2,
      }}
    >
      <CardContent>
        <CardContent
          sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
        >
          <Icons
            iconName="ArrowBack"
            fontSize="large"
            style={{
              backgroundColor: theme.palette.primary.main,
              color: "#fff",
              marginRight: 20,
            }}
            to="/Ubicaciones"
            tooltip={t("buttons.back")}
          />
          <Typography variant="h3" sx={{ flex: "1", fontWeight: "bold" }}>
            {title} {t("locations.title")}
          </Typography>
        </CardContent>
        <Divider sx={{ maxWidth: "calc(100% - 32px)", margin: "auto" }} />
        <Card
          variant="outlined"
          sx={{
            overflow: "hidden",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
            border: "1px solid rgba(0, 0, 0, 0.1)",
            borderRadius: 2,
            maxWidth: "calc(100% - 32px)",
            margin: "auto",
            marginTop: 2,
          }}
        >
          <CardContent sx={{ maxWidth: "calc(100% - 64px)", margin: "auto" }}>
            <Typography
              variant="h5"
              sx={{
                flex: "1",
                color: theme.palette.primary.main,
              }}
            >
              {t("locations.addOrEdit.locationInfo")}
            </Typography>
            <Divider sx={{ maxWidth: "100%", marginTop: 2 }} />
            <Grid container spacing={2} sx={{ marginTop: 2 }}>
              <Grid item xs={12} md={3}>
                <TextField
                  select
                  label={t("locations.locationType")}
                  name="idUbicacionTipo"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="standard"
                  size="small"
                  value={tipoUbicacion || 0}
                  onChange={handleChangeLocationsType}
                  fullWidth
                  error={!!errors.idUbicacionTipo}
                  helperText={errors.idUbicacionTipo}
                >
                  <MenuItem key={0} value={0}>
                    {t("select")}
                  </MenuItem>
                  {tiposUbicacion.map((tipo) => (
                    <MenuItem
                      key={tipo.idUbicacionTipo}
                      value={tipo.idUbicacionTipo}
                    >
                    {language == "es" ? tipo.descripcion : tipo.descripcionIngles}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label={t("locations.code")}
                  name="codigo"
                  variant="standard"
                  fullWidth
                  onChange={handleChange}
                  value={locationData.codigo || ""}
                  error={!!errors.codigo}
                  helperText={errors.codigo}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label={t("locations.name")}
                  name="nombre"
                  variant="standard"
                  fullWidth
                  onChange={handleChange}
                  value={locationData.nombre || ""}
                  error={!!errors.nombre}
                  helperText={errors.nombre}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  select
                  label={t("locations.addOrEdit.country")}
                  name="idPais"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="standard"
                  size="small"
                  value={country || 0}
                  onChange={handleChangeCountrys}
                  fullWidth
                  error={!!errors.idPais}
                  helperText={errors.idPais}
                >
                  <MenuItem key={0} value={0}>
                    {t("select")}
                  </MenuItem>
                  {countrys.map((tipo) => (
                    <MenuItem key={tipo.idPais} value={tipo.idPais}>
                      {tipo.nombre}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label={t("locations.addOrEdit.state")}
                  name="estado"
                  variant="standard"
                  fullWidth
                  onChange={handleChange}
                  value={locationData.estado || ""}
                  error={!!errors.estado}
                  helperText={errors.estado}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label={t("locations.addOrEdit.city")}
                  name="ciudad"
                  variant="standard"
                  fullWidth
                  onChange={handleChange}
                  value={locationData.ciudad || ""}
                  error={!!errors.ciudad}
                  helperText={errors.ciudad}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label={t("locations.addOrEdit.postalCode")}
                  name="codigoPostal"
                  variant="standard"
                  fullWidth
                  onChange={handleChange}
                  value={locationData.codigoPostal || ""}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label={t("locations.addOrEdit.neighborhood")}
                  name="colonia"
                  variant="standard"
                  fullWidth
                  onChange={handleChange}
                  value={locationData.colonia || ""}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label={t("locations.addOrEdit.street")}
                  name="calle"
                  variant="standard"
                  fullWidth
                  onChange={handleChange}
                  value={locationData.calle || ""}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label={t("locations.addOrEdit.exteriorNumber")}
                  name="numeroExterior"
                  variant="standard"
                  fullWidth
                  onChange={handleChange}
                  value={locationData.numeroExterior || ""}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label={t("locations.addOrEdit.email")}
                  name="email"
                  variant="standard"
                  onChange={handleChange}
                  fullWidth
                  value={locationData.email || ""}
                  error={!!errors.email}
                  helperText={errors.email}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label={t("locations.addOrEdit.phone")}
                  name="numeroTelefono"
                  variant="standard"
                  onChange={handleChange}
                  fullWidth
                  value={locationData.numeroTelefono || ""}
                  onKeyDown={handleNumberInput}
                  inputProps={{ maxLength: 10 }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label={t("locations.addOrEdit.schedule")}
                  name="horario"
                  variant="standard"
                  onChange={handleChange}
                  fullWidth
                  value={locationData.horario || ""}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label={t("locations.addOrEdit.rfc")}
                  name="rfc"
                  variant="standard"
                  onChange={handleChange}
                  fullWidth
                  value={locationData.rfc || ""}
                />
              </Grid>
            </Grid>


          </CardContent>
        </Card>


        <Card
          variant="outlined"
          sx={{
            overflow: "hidden",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
            border: "1px solid rgba(0, 0, 0, 0.1)",
            borderRadius: 2,
            maxWidth: "calc(100% - 32px)",
            margin: "auto",
            marginTop: 2,
          }}
        >
          <CardContent sx={{ maxWidth: "calc(100% - 64px)", margin: "auto" }}>

            <Typography
              variant="h5"
              sx={{
                flex: "1",
                color: theme.palette.primary.main,
              }}
            >
              {t("locations.addOrEdit.contacts")}
            </Typography>
            <Divider sx={{ maxWidth: "100%", marginTop: 2 }} />
            <Grid container spacing={2} sx={{ marginTop: 2 }}>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  options={contact}
                  getOptionLabel={getOptionLabelContacts}
                  value={selectedOptionContacts}
                  isOptionEqualToValue={isOptionEqualToValueContacts}
                  onChange={handleChangeContacts}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("locations.addOrEdit.contact")}
                      variant="standard"
                      error={!!errors.idContacto}
                      helperText={errors.idContacto}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <Checkbox
                  checked={selectedOptionCheck}
                  onChange={handleCheckboxChange}
                />
                <Typography>{t("locations.addOrEdit.requiresEmail")}</Typography>
              </Grid>
              <Grid item xs={2}>
                <Icons
                  iconName="Add"
                  fontSize="large"
                  onClick={handleChangeAgregar}
                  style={{
                    marginLeft: "auto",
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.white.main,
                  }}
                  tooltip={t("buttons.add")}
                />
              </Grid>
            </Grid>
            <Grid>
              <Paper
                sx={{
                  width: "100%",
                  margin: "auto",
                  overflow: "hidden",
                  boxShadow: "none",
                  border: "none",
                }}
              >
                <TableContainer>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ fontWeight: "bold" }} key="icono">
                          {t("buttons.action")}
                        </TableCell>
                        <TableCell style={{ fontWeight: "bold" }} key="orden">
                          {t("locations.addOrEdit.order")}
                        </TableCell>
                        <TableCell
                          style={{ fontWeight: "bold" }}
                          key="correo"
                        >
                          {t("locations.addOrEdit.contact")}
                        </TableCell>
                        <TableCell
                          style={{ fontWeight: "bold" }}
                          key="envioCorreo"
                        >
                          {t("locations.addOrEdit.sendEmail")}
                        </TableCell>
                        <TableCell key="action"></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rowsubicacionContactos.length === 0 && (
                        <TableRow>
                          <TableCell colSpan={4 + 1} align="center">
                            {t("locations.addOrEdit.noRecordsAvailable")}
                          </TableCell>
                        </TableRow>
                      )}
                      {rowsubicacionContactos.map((row, index) => {
                        return (
                          <TableRow
                            key={index}
                            draggable
                            onDragStart={(e) => handleDragStart(e, index)}
                            onDragOver={(e) => handleDragOver(e)}
                            onDrop={(e) => handleDrop(e, index)}
                            onDragEnd={handleDragEnd}
                            className={draggedRow === index ? "dragging" : ""}
                          >
                            <TableCell>
                              <IconButton>
                                <UnfoldMore />
                              </IconButton>
                            </TableCell>
                            <TableCell sx={{ marginLeft: "10px" }}>
                              {row.orden !== null && row.orden !== "" ? (
                                row.orden
                              ) : (
                                <i>{t("pagination.notAvailable")}</i>
                              )}
                            </TableCell>
                            <TableCell sx={{ marginLeft: "10px" }}>
                              {row.correo !== null &&
                                row.correo !== "" ? (
                                row.correo
                              ) : (
                                <i>{t("pagination.notAvailable")}</i>
                              )}
                            </TableCell>
                            <TableCell sx={{ marginLeft: "10px" }}>
                              {row.envioCorreo !== null &&
                                row.envioCorreo !== "" ? (
                                row.envioCorreo ? (
                                  t("buttons.yes")
                                ) : (
                                  t("buttons.no")
                                )
                              ) : (
                                <i>{t("pagination.notAvailable")}</i>
                              )}
                            </TableCell>
                            <TableCell>
                              <Icons
                                iconName="Remove"
                                fontSize="medium"
                                style={{
                                  backgroundColor: theme.palette.danger.main,
                                  color: "#fff",
                                }}
                                onClick={() => handleRemoveUnit(index)}
                                tooltip={t("buttons.remove")}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Grid>

            <Grid container justifyContent="flex-end" sx={{ marginTop: 2 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                {t("locations.addOrEdit.save")}
              </Button>
            </Grid>

          </CardContent>
        </Card>

      </CardContent>
    </Card>
  );
}
